import calls from '@/backend/api-calls'

const state = {
  token: localStorage.getItem('user-token') || '',
  status: '',
  user: JSON.parse(localStorage.getItem('user-object')) || '',
  permission: '',
  role: '',
  changingPassword: false
}

const getters = {
  isAuthenticated: state => !!state.token,
  authStatus: state => state.status,
  getToken: state => state.token
}

const actions = {
  authLogin: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      commit('loginRequested');

      calls.user.login(data)
        .then(resp => {
          const token = resp.data.auth_token;
          commit('authSuccess', token);
          localStorage.setItem('user-token', token); // store the token in localstorage
          delete resp.data.auth_token;
          
          commit('setUser', resp.data);
          localStorage.setItem('user-object', JSON.stringify(resp.data));
          resolve(resp);
        })
        .catch(err => {
          commit('authError', err);
          localStorage.removeItem('user-token');
          reject(err);
        })
    })
  },
  authLogout: ({commit}) => {
    return new Promise((resolve, reject) => {
      calls.user.logout().then(
        resp => {
          commit('removeToken');
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  authChangePassword: ({commit}, data) => {
    return new Promise((resolve, reject) => {
      calls.user.changePassword(data).then(
        resp => {
          commit('removeToken');
          commit("app/setNotification", {
            type: 'success',
            status: true,
            message: 'Password changed successfully. Please log in again with your new password.'
          }, { root: true });
          resolve(resp);
        }
      ).catch(err => reject(err));
    })
  },
  authExpired: ({commit}) => {
    return new Promise((resolve) => {
      commit('removeToken');
      resolve();
    })
  }
}

const mutations = {
  //loading status
  loginRequested: (state) => {
    state.status = 'loading';
  },
  //login success
  authSuccess: (state, token) => {
    state.status = 'success';
    state.token = token;
  },
  authError: (state) => {
    state.status = 'error';
  },
  removeToken: (state) => {
    localStorage.removeItem('user-token');
    localStorage.removeItem('user-object');
    state.token = '';
  },
  setUser: (state, user) => {
    state.user = user;
  },
  setChangingPassword: (state, status) => {
    state.changingPassword = status;
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
